import { styled } from "@mui/material/styles";
import { DataGrid } from "@mui/x-data-grid/DataGrid";
// const getBackgroundColor = (color: string, mode: string) =>
//     mode === 'dark' ? darken(color, 0.7) : lighten(color, 0.7);

// const getHoverBackgroundColor = (color: string, mode: string) =>
//     mode === 'dark' ? darken(color, 0.6) : lighten(color, 0.6);

// const getSelectedBackgroundColor = (color: string, mode: string) =>
//     mode === 'dark' ? darken(color, 0.5) : lighten(color, 0.5);

// const getSelectedHoverBackgroundColor = (color: string, mode: string) =>
//     mode === 'dark' ? darken(color, 0.4) : lighten(color, 0.4);

export const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  "@keyframes rowHighlight": {
    "0%": {
      backgroundColor: theme.palette.mode === "dark" ? "#4a4a1a" : "#fff9c4",
    },
    "100%": {
      backgroundColor: theme.palette.background.default,
    },
  },
  ".MuiDataGrid-columnHeaderTitle": {
    fontWeight: "bold !important",
    overflow: "visible !important",
  },
  "& .MuiDataGrid-columnSeparator": {
    display: "none",
  },
  "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
    outline: "none !important",
    border: "none !important",
    boxShadow: "none !important",
  },
  "& .MuiDataGrid-cell": {
    userSelect: "none",
  },
  "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
    {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
  "& .content-cell": {
    userSelect: "none",
  },
  "& .row-highlight-animation": {
    animation: "rowHighlight 1.5s ease-out",
  },
  "& .top-row-theme": {
    "& .MuiDataGrid-cell": {
      boxShadow: "none",
      backgroundColor: theme.palette.background.default,
    },
  },
  "& .grid-theme": {
    backgroundColor: theme.palette.background.default,
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    "&.Mui-selected": {
      backgroundColor: theme.palette.action.selected,
      "&:hover": {
        backgroundColor: theme.palette.action.focus,
      },
    },
    "& .MuiDataGrid-cell": {
      "&.MuiDataGrid-cell--editing": {
        backgroundColor: theme.palette.background.default,
      },
    },
    //  '& .MuiDataGrid-toolbarContainer': {
    //     backgroundColor: theme.palette.action.hover
    // },
  },
}));
